import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteStackFilterParams {
  id: string;
}

const deleteStackFilter: MutationFunction<
  DeleteStackFilterParams,
  DeleteStackFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockStackFilter(args), { delay: 1000, failureRate: 0 });
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteStackFilterParams>(
    `/search-filters/${args.id}`,
    {
      method: 'DELETE',
    },
  );

  // DELETE requests typically return 204 No Content (no response.data)
  // Check for successful status codes instead of response.data
  if (response.status === 204 || response.status === 200) {
    return { id: args.id }; // Return the ID to confirm deletion
  }

  throw new Error('Failed to delete stack filter');
};

export default deleteStackFilter;

const _mockStackFilter = (stackFilter: DeleteStackFilterParams) => {
  return {
    id: stackFilter.id,
  };
};
